module.exports = __webpack_public_path__ + "img/功能权限.9d5ce374.svg";